import { YMInitializer as InternalInitializer } from 'react-yandex-metrika';

interface IYandexMetricsProps {}

export const YandexMetrika: React.FC<IYandexMetricsProps> = () => {
  if (process.env.NODE_ENV === 'development') {
    return null;
  }

  return (
    <InternalInitializer
      version="2"
      accounts={[85612228]}
      options={{
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        ecommerce: 'dataLayer',
      }}
    />
  );
};
